<form nz-form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div *ngFor="let field of fields" [ngClass]="field.class || ''">
        <ng-container [ngSwitch]="field.type">
            <nz-form-item *ngSwitchCase="'hidden'">
                <input [hidden]="true" nz-input [formControlName]="field.name" />
            </nz-form-item>

            <!-- Input Field -->
            <nz-form-item *ngSwitchCase="'input'">
                <ng-container *ngIf="shouldHide(field)">
                    <nz-form-label [nzSm]="6" [nzXs]="24" [nzRequired]="field.required">{{ field.label
                        }}</nz-form-label>
                    <nz-form-control [nzSm]="15" [nzXs]="24" [nzErrorTip]="getErrorTpl(field)">
                        <!-- [readonly]="field.readonly?true:false" -->
                        <input nz-input auto-focus [enabled]="field.autofocus? true:false"
                            [readonly]="getReadonly(field)" [formControlName]="field.name"
                            [placeholder]="field.placeholder" />
                    </nz-form-control>
                </ng-container>

            </nz-form-item>

            <!-- Input Field -->
            <nz-form-item *ngSwitchCase="'date'">
                <nz-form-label [nzSm]="6" [nzXs]="24" [nzRequired]="field.required">{{ field.label
                    }}</nz-form-label>
                <nz-form-control [nzSm]="15" [nzXs]="24" [nzErrorTip]="getErrorTpl(field)">
                    <nz-date-picker [formControlName]="field.name"></nz-date-picker>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item *ngSwitchCase="'dateTime'">
                <ng-container *ngIf="shouldHide(field)">

                    <nz-form-label [nzSm]="6" [nzXs]="24" [nzRequired]="field.required">
                        {{ field.label }}
                    </nz-form-label>

                    <nz-form-control [nzSm]="15" [nzXs]="24" [nzErrorTip]="getErrorTpl(field)">
                        <nz-date-picker [formControlName]="field.name" nzShowTime nzFormat="yyyy-MM-dd HH:mm:ss"
                            [nzPlaceHolder]="field.placeholder" [nzDisabled]="getReadonly(field)"
                            [nzDisabledDate]="field.minDate ? disablePastDateTime : null">
                        </nz-date-picker>
                    </nz-form-control>

                </ng-container>
            </nz-form-item>
            <!-- Input Field -->
            <nz-form-item *ngSwitchCase="'quill-text'">
                <nz-form-label [nzSm]="6" [nzXs]="24" [nzRequired]="field.required">
                    {{ field.label }}
                </nz-form-label>
                <nz-form-control [nzSm]="15" [nzXs]="24" [nzErrorTip]="getErrorTpl(field)">
                    <quill-editor [formControlName]="field.name" [modules]="modules" [formats]="formats" theme="snow"
                        [readOnly]="getReadonly(field)" [placeholder]="field.placeholder" class="quill-textarea">
                    </quill-editor>
                </nz-form-control>
            </nz-form-item>

            <!-- Input Field -->
            <nz-form-item *ngSwitchCase="'editor'">
                <nz-form-label [nzSm]="6" [nzXs]="24" [nzRequired]="field.required">{{ field.label
                    }}</nz-form-label>
                <nz-form-control [nzSm]="15" [nzXs]="24" [nzErrorTip]="getErrorTpl(field)">
                    <app-rich-text-editor [formControlName]="field.name"
                        [placeholder]="field.placeholder"></app-rich-text-editor>
                </nz-form-control>
            </nz-form-item>


            <!-- Input number Field -->
            <nz-form-item *ngSwitchCase="'number'">
                <nz-form-label [nzSm]="6" [nzXs]="24" [nzRequired]="field.required">{{ field.label
                    }}</nz-form-label>
                <nz-form-control [nzSm]="15" [nzXs]="24" [nzErrorTip]="getErrorTpl(field)">
                    <nz-input-number style="width: 100%;" [nzMin]="0" [formControlName]="field.name" [nzMax]="1000000"
                        [nzStep]="1"></nz-input-number>
                </nz-form-control>
            </nz-form-item>

            <!-- Select Field -->
            <nz-form-item *ngSwitchCase="'select'">
                <ng-container *ngIf="shouldHide(field)">
                    <nz-form-label [nzSm]="6" [nzXs]="24" [nzRequired]="field.required">{{ field.label
                        }}</nz-form-label>
                    <nz-form-control [nzSm]="15" [nzXs]="24" [nzErrorTip]="getErrorTpl(field)">
                        <nz-select nzAllowClear auto-focus [enabled]="field.autofocus? true:false"
                            [nzDisabled]="getReadonly(field)" [nzMode]="field.multiple ? 'tags' : 'default'"
                            [formControlName]="field.name" [attr.nzPlaceHolder]="field.placeholder">
                            @if(field.dependOn) {
                            <nz-option *ngFor="let option of getFieldOptions(field)" [nzLabel]="option.text"
                                [nzValue]="option.value"></nz-option>
                            } @else {
                            <nz-option *ngFor="let option of field.options" [nzLabel]="option.text"
                                [nzValue]="option.value"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </ng-container>
            </nz-form-item>

            <nz-form-item *ngSwitchCase="'tree'">
                <nz-form-label [nzSm]="6" [nzXs]="24" [nzRequired]="field.required">{{ field.label
                    }}</nz-form-label>
                <nz-form-control [nzSm]="15" [nzXs]="24" [nzErrorTip]="getErrorTpl(field)">
                    <nz-tree #nzTreeComponent (nzCheckboxChange)="nzCheck($event,field.name)"
                        [nzCheckedKeys]="form.get(field.name).value" [nzData]="field.treedata" nzCheckable
                        [nzExpandedKeys]="expandedKeys">
                    </nz-tree>
                    <input [hidden]="true" nz-input [formControlName]="field.name" />
                </nz-form-control>
            </nz-form-item>

            <!-- Radio Field -->
            <nz-form-item *ngSwitchCase="'radio'">
                <nz-form-label [nzSm]="6" [nzXs]="24" [nzRequired]="field.required">{{ field.label
                    }}</nz-form-label>
                <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="getErrorTpl(field)">
                    <nz-radio-group [formControlName]="field.name">
                        <label nz-radio *ngFor="let option of field.options" [nzValue]="option.value">
                            {{ option.text }}
                        </label>
                    </nz-radio-group>
                </nz-form-control>
            </nz-form-item>
            <nz-row *ngSwitchCase="'image'">
                <nz-col [nzSpan]="20">
                    <!-- Image Field -->
                    <div style="display: flex;
                        flex-grow: 1;
                        flex-direction: column;
                        align-items: center;
                        height: 100%;
                        flex-wrap: wrap;
                        flex-grow: 1;
                        padding:1rem;">
                        <nz-form-item>
                            <nz-form-label [nzRequired]="field.required">{{ field.label
                                }}</nz-form-label>
                            <nz-form-control [nzErrorTip]="getErrorTpl(field)">
                                <app-dyanmic-form-img [field]="field" [formGroup]="form"></app-dyanmic-form-img>
                                <input [hidden]="true" nz-input [formControlName]="field.name" />
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </nz-col>
            </nz-row>
            <nz-row *ngSwitchCase="'image-file'">
                <nz-col [nzSpan]="20">
                    <!-- Image Field -->
                    <div style="display: flex;
                        flex-grow: 1;
                        flex-direction: column;
                        align-items: center;
                        height: 100%;
                        flex-wrap: wrap;
                        flex-grow: 1;
                        padding:1rem;">
                        <nz-form-item>
                            <nz-form-label [nzRequired]="field.required">{{ field.label
                                }}</nz-form-label>
                            <nz-form-control [nzErrorTip]="getErrorTpl(field)">
                                <app-dyanmic-form-img-file [field]="field" [multiple]="true"
                                    [formGroup]="form"></app-dyanmic-form-img-file>
                                <input [hidden]="true" nz-input [formControlName]="field.name" />
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </nz-col>
            </nz-row>
            <nz-row *ngSwitchCase="'multi-image-file'">
                <nz-col [nzSpan]="20">
                    <nz-form-item>
                        <nz-form-label [nzRequired]="field.required">
                            {{ field.label }}
                        </nz-form-label>

                        <nz-form-control [nzErrorTip]="getErrorTpl(field)">
                            <app-dyanmic-form-img-file [field]="field" [formGroup]="form" [multiple]="true">
                            </app-dyanmic-form-img-file>

                            <input hidden nz-input [formControlName]="field.name" />
                        </nz-form-control>
                    </nz-form-item>
                </nz-col>
            </nz-row>


        </ng-container>

    </div>
    <nz-form-item *ngIf="form.errors?.['dateRangeInvalid']">
        <nz-form-control [nzOffset]="8" [nzSpan]="14" [nzValidateStatus]="'error'">
            <div class="ant-form-item-explain ant-form-item-explain-error">
                <i nz-icon nzType="close-circle"></i>
                Start Date must be before End Date
            </div>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="!isFromModal">
        <nz-form-control [nzOffset]="8" [nzSpan]="14">
            <button nz-button nzType="primary" type="submit">Submit</button>
            <button nz-button>Cancel</button>
        </nz-form-control>
    </nz-form-item>

</form>